<template>
  <div class="contact">
    <mbHeader class="contact-mobile-header" :title="curIsChinese ? '关于我们' : 'About'" :left="true" :showCompany="true">
      <button class="contact-mobile-locale" type="button" @click.stop="langChanged">中文 / EN</button>
    </mbHeader>

    <div class="company">
      <img class="top-image" src="../assets/img/about.png" alt="Vast Import" />
    </div>

    <section class="about-showcase" aria-label="About Vast Import">
      <article class="about-panel company-profile">
        <span class="profile-mark" aria-hidden="true"></span>
        <p class="section-kicker">ABOUT VAST IMPORT</p>
        <h2>Company Profile</h2>
        <p class="profile-copy">
          Vast Import Inc. connects quality Asian food brands with restaurants,
          retailers and hospitality partners. We focus on dependable sourcing,
          thoughtful service and products our customers are proud to share.
        </p>
        <div class="profile-highlights" aria-label="Our values">
          <span>Quality First</span>
          <span>Reliable Supply</span>
          <span>Trusted Partners</span>
          <span>Customer Focus</span>
        </div>
      </article>

      <article class="about-panel brand-story">
        <div class="brand-image-wrap">
          <img src="../assets/img/afmLocation.png" alt="Asian food products supplied by Vast Import" />
        </div>
        <div class="brand-copy">
          <p class="section-kicker">OUR STORY</p>
          <h2>Brand Story</h2>
          <p>
            From pantry staples to restaurant-ready ingredients, we bring
            trusted products closer to the businesses and communities that
            enjoy them every day.
          </p>
        </div>
      </article>

      <article class="about-panel milestones">
        <div class="milestone-heading">
          <p class="section-kicker">HOW WE GROW</p>
          <h2>Company Milestones</h2>
        </div>
        <div class="timeline-scroll">
          <a-timeline class="company-timeline" mode="alternate">
            <a-timeline-item
              v-for="item in milestones"
              :key="item.title"
              color="#d7a54c"
            >
              <div class="timeline-card">
                <strong>{{ item.title }}</strong>
                <span>{{ item.description }}</span>
              </div>
            </a-timeline-item>
          </a-timeline>
        </div>
      </article>

      <article class="about-panel customer-cases">
        <div class="cases-heading">
          <div>
            <p class="section-kicker">WHO WE SERVE</p>
            <h2>Customer Cases</h2>
          </div>
          <span>VAST IMPORT INC.</span>
        </div>
        <div class="case-grid">
          <figure>
            <img src="../assets/img/afmLocation.png" alt="Food service products" />
            <figcaption>Chain Restaurants</figcaption>
          </figure>
          <figure>
            <img src="../assets/img/afmLocation1.png" alt="Fresh ingredients" />
            <figcaption>Hotels &amp; Catering</figcaption>
          </figure>
          <figure>
            <img src="../assets/img/Contact.png" alt="Retail store supplied with products" />
            <figcaption>Retail Partners</figcaption>
          </figure>
        </div>
      </article>
    </section>

    <div class="main-content">
      <section class="info-left">
        <img class="location-image" src="../assets/img/map.png" alt="Vast Import products"/>
        <div class="location">
          <h2>LOCATION</h2>
          <p>1. 13760 Midway St, Cerrito CA 90703</p>
          <p>2. 5660 Melvina Pl Maspeth NY 11378</p>
        </div>
      </section>

      <section class="info-right">
        <div class="contact-heading">
          <!-- <p class="eyebrow">VAST IMPORT INC.</p>
          <h1>LOCATION</h1> -->
          <p class="wechat-line">{{ $t('wechat') }} ID: Vast Import Inc.</p>
          <p class="contact-line">LA: la_office@vastimport.com</p>
          <p class="contact-line">NY: office@vastimport.com</p>
          <p class="contact-line">LA: (626) 270-5010</p>
          <p class="contact-line">NY: (929) 462-0035 </p>
          <p class="contact-line">{{ $t('days_a_week') }}</p>
          <p class="contact-line">10am – 7pm</p>
        </div>

        <div v-show="postContactSuccess" class="contact-success">
          Contact Form Submitted!
        </div>

        <form class="help-form" v-show="!postContactSuccess" @submit.prevent="sendContactUsForm">
          <div class="input-item">
            <p class="input-title">{{ $t('name') }}</p>
            <input class="input-box" :placeholder="$t('name')" v-model="form.Name" @keyup="checkForm"/>
            <span v-if="error.Name" class="error-message">
              <svg class="icon icon-error"><path d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path></svg>
              {{error.Name}}
            </span>
          </div>

          <div class="input-item">
            <p class="input-title">{{ $t('email') }}</p>
            <input class="input-box" :placeholder="$t('email')" v-model="form.Email" @keyup="checkForm"/>
            <span v-if="error.Email" class="error-message">
              <svg class="icon icon-error"><path d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path></svg>
              {{error.Email}}
            </span>
          </div>

          <div class="input-item">
            <p class="input-title">{{$t('phone_optional')}}</p>
            <input class="input-box" placeholder="(000)-000-0000" v-model="form.PhoneNumber" @keyup="checkForm"/>
            <span v-if="error.PhoneNumber" class="error-message">
              <svg class="icon icon-error"><path d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path></svg>
              {{error.PhoneNumber}}
            </span>
          </div>

          <div class="input-item">
            <p class="input-title">{{ $t('message') }}</p>
            <textarea class="input-box" :placeholder="$t('message')" v-model="form.Message" @keyup="checkForm" rows="3"></textarea>
            <span v-if="error.Message" class="error-message">
              <svg class="icon icon-error"><path d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path></svg>
              {{error.Message}}
            </span>
          </div>

          <div class="form-footer">
            <div class="direct-contact">
              <!-- <a href="mailto:help@vast.com"><span aria-hidden="true">✉</span> help@vast.com</a>
              <p><span aria-hidden="true">⌚</span> 10am – 7pm</p> -->
            </div>
            <div class="button-cont">
              <button type="submit">{{$t('send')}}</button>
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Timeline from 'ant-design-vue/lib/timeline';
import 'ant-design-vue/lib/timeline/style/index.css';
import { validateEmail, validatePhoneNumber } from "../../config/validation";
import mbHeader from "../components/mobile/mbHeader";
import {locales} from "../mixin";
export default {
  name: "contact",
  mixins: [locales],
  components: {
    ATimeline: Timeline,
    ATimelineItem: Timeline.Item,
    mbHeader,
  },
  data(){
    return{
      milestones: [
        { title: 'Our Start', description: 'A clear vision' },
        { title: 'Supply', description: 'Reliable sourcing' },
        { title: 'New Lines', description: 'More selections' },
        { title: 'Partners', description: 'Growing together' },
        { title: 'Digital', description: 'Easier service' },
        { title: 'Today', description: 'Moving forward' },
      ],
      form: {
        Name: '',
        Email: '',
        PhoneNumber: '',
        Message: '',
      },
      error:{
        Name: '',
        Email: '',
        PhoneNumber: '',
        Message: '',
      },
    }
  },
  methods: {
    ...mapActions('contact', ['postContact']),
    ...mapMutations('contact', ['resetPostContact']),
    sendContactUsForm(e) {
      e.preventDefault();
      this.submit = false;
      if (!this.error.Name && !this.error.Email && !this.error.PhoneNumber && !this.error.Message) {
        this.postContact(this.form)
      }
    },
    async checkForm() {
      if (!this.form.Name){
        this.error.Name = 'Name cannot be empty.'
      } else {
        this.error.Name = '';
      }
      if (validateEmail(this.form.Email)){
        this.error.Email = 'Email is invalid.'
      } else {
        this.error.Email = '';
      }
      if (!this.form.Message) {
        this.error.Message = 'Message cannot be empty.'
      } else {
         this.error.Message = '';
      }
      const PhoneNumber = this.form.PhoneNumber
      if (PhoneNumber && validatePhoneNumber(PhoneNumber)) {
        this.error.PhoneNumber = 'Phone Number is invalid.'
      } else {
        this.error.PhoneNumber = '';
      }
    },
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    postContactSuccess: state => state.contact.postContactSuccess,
  }),
  watch: {
    postContactSuccess(newValue, oldValue) {
      if (newValue == true) {
        let that = this;
        this.submit = true;
        this.form.Name = '';
        this.form.Email = '';
        this.form.PhoneNumber = '';
        this.form.Message = '';
        setTimeout(function(){
          that.resetPostContact(false)
        }, 3000);

      }
    },
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/contact.less";
</style>

<style lang="less">
.contact-mobile-header {
  display: none !important;
}

@media only screen and (max-width: 1032px) {
  .contact {
    padding-top: 64px !important;

    > .company {
      margin-top: 0 !important;
    }
  }

  .contact-mobile-header {
    display: flex !important;
    height: 64px !important;
    padding: 0 16px !important;
    gap: 0;
    justify-content: flex-start !important;
    background: linear-gradient(135deg, #435b38 0%, #2f452c 100%) !important;
    box-shadow: 0 3px 12px rgba(37, 50, 32, .2);

    > .left {
      display: flex;
      flex: 0 0 20px;
      width: 20px;
      height: 38px;
      padding: 7px 3px;
      align-items: center;

      img {
        width: auto;
        height: 16px;
        object-fit: contain;
      }
    }

    > .min {
      flex: 0 1 auto;
      min-width: 66px;
      overflow: hidden;
      color: #fff;
      font-size: 18px;
      font-weight: 800;
      line-height: 1;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    > .navbar-select {
      flex: 1 1 150px;
      width: auto;
      min-width: 112px;
      max-width: 190px;
      margin-left: auto;

      .el-input__inner {
        height: 34px;
        padding: 0 36px 0 16px;
        border: 1px solid rgba(255, 255, 255, .56);
        border-radius: 18px;
        background: rgba(255, 255, 255, .12);
        box-shadow: 0 3px 7px rgba(0, 0, 0, .2);
        color: #fff;
        font-size: 15px;
        font-weight: 700;
        line-height: 34px;
      }

      .el-input__suffix,
      .el-input__suffix-inner {
        display: flex;
        height: 100%;
        align-items: center;
      }

      .el-select .el-input .el-select__caret {
        position: static;
        color: #fff;
        font-size: 15px;
        line-height: 1;
      }
    }

    .contact-mobile-locale {
      flex: 0 0 auto;
      padding: 0;
      border: 0;
      background: transparent;
      color: #fff;
      font-size: 14px;
      font-weight: 700;
      white-space: nowrap;
    }

    > .navbar-select + .contact-mobile-locale {
      margin-left: 12px;
    }

    > .min + .contact-mobile-locale {
      margin-left: auto;
    }
  }
}

@media only screen and (max-width: 390px) {
  .contact-mobile-header {
    padding: 0 10px !important;
    gap: 0;

    > .min {
      font-size: 16px;
    }

    > .navbar-select {
      min-width: 102px;

      .el-input__inner {
        padding-left: 12px;
        font-size: 13px;
      }
    }

    .contact-mobile-locale {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/contact.vue